import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../@bizkeytech";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";

/**@inheritDoc*/
export class ReportsController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the Time Tracking report of the organization.
     *
     * @param request           The request to list the organization groups.
     * @param abortController   The abort controller that will be used to cancel the request.
     */
    public async getTimeTrackingReport(request: models.GetTimeTrackingReportRequest, abortController?: AbortController): models.GetTimeTrackingReportResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.reports.getPayrollReport,
            signal: abortController?.signal,
            params: {
                ValidFrom: request.startDateTime,
                ValidTo: request.endDateTime,
            }
        });
    }

}


export * from './index.types';
export default ReportsController;